<template>

  <div class="supplier-registration">
    <h2 class="page-title">农资供应商入驻申请</h2>
    <p class="page-desc">请按照指引完成申请流程，我们将在3个工作日内完成审核</p>

    <el-card class="form-card">
      <h3 class="section-title">店铺基本信息</h3>

      <el-form :model="formData" :rules="rules" ref="registrationForm" label-width="105px" class="registration-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="店铺名称" prop="name">
              <el-input v-model="formData.name" placeholder="请输入店铺名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人电话" prop="phone">
              <el-input v-model="formData.phone" placeholder="请输入法人电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="formData.contactPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="formData.contactPhone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="经营地址" prop="address">
          <el-input v-model="formData.address" placeholder="请输入经营地址"></el-input>
        </el-form-item>

        <el-form-item label="营业执照" prop="businessLicense">
          <div class="upload-tips">
            请上传清晰的营业执照照片或扫描件，支持JPG、PNG、PDF格式，文件大小不超过5MB
          </div>

          <div class="id-card-container">
            <el-upload action=""
              :class="formData.businessLicense ? 'picture-card-uploader no-image ' : 'id-card-uploader'" :limit="1"
              :auto-upload="false" ref="upload" :on-change="upBusinessLicense" :file-list="businessLicenseList"
              v-bind="formData.businessLicense ? { 'list-type': 'picture-card' } : {}" :before-upload="beforeUpload">

              <div class="upload-box">
                <i class="el-icon-picture-outline"></i>
                <div>营业执照</div>
                <div class="upload-status">
                  {{ formData.businessLicense ? "已上传" : "未上传" }}
                </div>
              </div>
              <div slot="file" slot-scope="{ file }">
                <el-image ref="preview" style="height: 115px" class="el-upload-list__item-thumbnail" :src="file.url"
                  :preview-src-list="BigBusinessLicense" alt="" :initial-index="0" />

                <span class="el-upload-list__item-actions">
                  <span v-if="!file.isShow" class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </el-form-item>


        <el-form-item label="身份证明" prop="bossCardFront">
          <div class="upload-tips">
            请上传个人身份证正反面照片，支持JPG、PNG格式，文件大小不超过5MB
          </div>
          <div class="id-card-container">

            <el-upload action="" :class="formData.bossCardFront
              ? 'picture-card-uploader no-image '
              : 'id-card-uploader'
              " :limit="1" :auto-upload="false" ref="upload" :on-change="upBossCardFront"
              :file-list="bossCardFrontList" v-bind="formData.bossCardFront ? { 'list-type': 'picture-card' } : {}
                ">

              <div class="upload-box">
                <i class="el-icon-picture-outline"></i>
                <div>上传身份证人面像</div>
                <div class="upload-status">
                  {{ formData.bossCardFront ? "已上传" : "未上传" }}
                </div>
              </div>
              <div slot="file" slot-scope="{ file }">
                <el-image ref="preview2" style="height: 115px" class="el-upload-list__item-thumbnail" :src="file.url"
                  :preview-src-list="BigBossCardFront" alt="" :initial-index="0" />

                <span class="el-upload-list__item-actions">
                  <span v-if="!file.isShow" class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview2(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleRemove2(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>

            <!-- 
            <el-upload action="" :class="formData.bossCardBack
              ? 'picture-card-uploader no-image '
              : 'id-card-uploader'
              " :limit="1" :auto-upload="false" ref="upload" :on-change="upBossCardBack" :file-list="bossCardBackList"
              v-bind="formData.bossCardBack ? { 'list-type': 'picture-card' } : {}
                ">
              <div class="upload-box">
                <i class="el-icon-picture-outline"></i>
                <div>上传身份证国徽像</div>
                <div class="upload-status">
                  {{ formData.bossCardBack ? "已上传" : "未上传" }}
                </div>
              </div>
              <div slot="file" slot-scope="{ file }">
                <el-image ref="preview3" style="height: 115px" class="el-upload-list__item-thumbnail" :src="file.url"
                  :preview-src-list="BigbossCardBack" alt="" :initial-index="0" />

                <span class="el-upload-list__item-actions">
                  <span v-if="!file.isShow" class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview3(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleRemove3(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload> -->
            <el-upload action="" :class="formData.bossCardBack
              ? 'picture-card-uploader no-image '
              : 'id-card-uploader'
              " :limit="1" :auto-upload="false" ref="upload" :on-change="upBossCardBack" :file-list="bossCardBackList"
              v-bind="formData.bossCardBack ? { 'list-type': 'picture-card' } : {}
                ">

              <div class="upload-box">
                <i class="el-icon-picture-outline"></i>
                <div>上传身份证人面像</div>
                <div class="upload-status">
                  {{ formData.bossCardBack ? "已上传" : "未上传" }}
                </div>
              </div>
              <div slot="file" slot-scope="{ file }">
                <el-image ref="preview2" style="height: 115px" class="el-upload-list__item-thumbnail" :src="file.url"
                  :preview-src-list="BigBossCardFront" alt="" :initial-index="0" />

                <span class="el-upload-list__item-actions">
                  <span v-if="!file.isShow" class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview2(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete" @click="handleRemove2(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="企业对公账户" prop="bankCardNum" label-width="110px">
          <el-input  type="number" v-model="formData.bankCardNum" placeholder="请输入企业对公账户"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="对公账户名" prop="bankCompanyName">
              <el-input v-model="formData.bankCompanyName" placeholder="请输入对公账户名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行" prop="bankName">
              <el-input v-model="formData.bankName" placeholder="请输入开户行"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="form-buttons">
          <div style="text-align: right">
            <!-- v-if="!identityObj.shop||identityObj.shop.deleteFlag==1" -->
            <el-button @click="saveDraft" icon="el-icon-document">保存草稿</el-button>
            <!-- v-if="!identityObj.shop &&!identityObj.shop.deleteFlag==0" -->
            <el-button type="primary" @click="submitForm" icon="el-icon-check">提交申请</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import { uploadFile } from "@/api/fileApi";
import { saveShopApply } from "@/api/shfw";
import { selectShopApplyByCompanyId } from "@/api/shfw";
export default {
  name: "SupplierRegistration",
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      uploadUrl: `${window.globalUrl.HOME_API_WEI}/admin/file/upload`, //上传图片的地址
      formData: {
        name: "",
        phone: "",
        contactPerson: "",
        contactPhone: "",
        address: "",
        businessLicense: "",
        bossCardFront: "",
        bossCardBack: "",
        bankCardNum: "",
        bankCompanyName: "",
        bankName: "",
        identityObj: {},//身份信息
      },
      id: '',
      rules: {
        name: [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入法人联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入经营地址", trigger: "blur" },
        ],
        businessLicense: [
          { required: true, message: "请上传营业执照", trigger: "change" },
        ],
        bossCardFront: [
          {
            validator: (rule, value, callback) => {
              if (!value || !this.formData.bossCardBack) {
                callback(new Error("请上传身份证正面和反面"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        bossCardBack: [
          { required: true, message: "请上传身份证反面", trigger: "change" },
        ],
        bankCardNum: [
          { required: true, message: "请输入企业对公账户", trigger: "blur" },
        ],
        bankCompanyName: [
          { required: true, message: "请输入对公账户名", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
      },
      businessLicenseList: [], //回显图片-营业执照
      BigBusinessLicense: [], //大图预览- 营业执照

      bossCardFrontList: [], //回显图片-身份证正面
      BigBossCardFront: [], //回显图片-身份证正面

      bossCardBackList: [], //回显图片-身份证正面
      BigbossCardBack: [], //上传图片列表
    };
  },
  computed: {
    // ...mapGetters(["identityObj"]),
  },
  created() {
    // 从本地存储加载草稿
    const draft = localStorage.getItem('identityObj')
    if (draft) {
      try {
        this.identityObj = JSON.parse(draft)
      } catch (e) {
        console.error('解析草稿数据失败', e)
      }
    }
  },
  mounted() {
    this.showBasicInformation();
    this.getiIsShop();
  },
  methods: {
    //交互层

    handlePictureCardPreview(file) {
      //营业执照图片预览
      this.allpreview(this.businessLicenseList, "businessLicense");
    },
    handlePictureCardPreview2(file) {
      //营业执照图片预览
      this.allpreview(this.bossCardFrontList, "bossCardFront");
    },
    handlePictureCardPreview3(file) {
      //营业执照图片预览
      this.allpreview(this.bossCardBackList, "bossCardBack");
    },
    allpreview(file, type) {
      //统一进行执行预览
      // console.log(file.url, "查看");
      switch (type) {
        case "businessLicense":
          this.$nextTick(() => {
            this.previewList = [file.url]; // 设置预览列表为当前选择的图片
            this.$refs.preview.clickHandler();
          });
          break;
        case "bossCardFront":
          this.$nextTick(() => {
            this.previewList = [file.url]; // 设置预览列表为当前选择的图片
            this.$refs.preview2.clickHandler();
          });
          break;
        case "bossCardBack":
          this.$nextTick(() => {
            this.previewList = [file.url]; // 设置预览列表为当前选择的图片
            this.$refs.preview3.clickHandler();
          });
          break;
      }
    },

    handleRemove() {
      //删除营业执照
      this.BigBusinessLicense = [];
      this.businessLicenseList = [];
      this.formData.businessLicense = "";
    },
    handleRemove2() {
      //删除身份证正面
      this.BigBossCardFront = [];
      this.bossCardFrontList = [];
      this.formData.bossCardFront = "";
    },
    handleRemove3() {
      //删除身份证反面
      this.BigbossCardBack = [];
      this.bossCardBackList = [];
      this.formData.bossCardBack = "";
    },

    upBusinessLicense(file, fileList) {
      // 上传图片按钮-营业执照
      this.alluploadImages(file, "businessLicense", fileList);
    },
    upBossCardFront(file, fileList) {
      // 上传图片按钮-身份证正面
      this.alluploadImages(file, "bossCardFront", fileList);
    },
    upBossCardBack(file, fileList) {
      //上传图片按钮身份证反面
      this.alluploadImages(file, "bossCardBack", fileList);
    },

    async alluploadImages(file, type, fileList) {
      //调用上传接口，判断上传类型进行分类赋值
      try {
        let param = new FormData();
        param.append("catalog", "register");
        param.append("file", file.raw);
        let res = await uploadFile(param);
        if (res.code == 0) {
          const { url, sourceFileName } = res.data;
          const allUrl = this.baseUrl + "admin/file/get?ossFilePath=" + url;

          fileList.url = allUrl;
          fileList.url2 = url;

          switch (type) {
            case "businessLicense":
              this.BigBusinessLicense = [allUrl];
              this.businessLicenseList = fileList;
              this.formData.businessLicense = url;
              break;
            case "bossCardFront":
              this.BigBossCardFront = [allUrl];
              this.bossCardFrontList = fileList;
              this.formData.bossCardFront = url;
              break;
            case "bossCardBack":
              this.BigbossCardBack = [allUrl];
              this.bossCardBackList = fileList;
              this.formData.bossCardBack = url;
              break;
          }
        }
      } catch (err) {
        this.$message.error("上传失败，请稍后再试");
      }
    },

    beforeUpload(file) {
      //上传前图片的校验
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isPDF = file.type === "application/pdf";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG && !isPDF) {
        this.$message.error("上传文件只能是 JPG/PNG/PDF 格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      }
      return true;
    },

    //控制层
    async saveDraft() {
      //保存草稿
      // let { name, phone, address, businessLicense, bossCardFront,bossCardBack,  bankCardNum,
      //   bankName } = this.formData
      const valid = await new Promise((resolve, reject) => {
        this.$refs.registrationForm.validate((valid) => {
          resolve(valid);
        });
      });

      if (valid) {
        let params = {
          ...this.formData,
          draftFlag: 1,
          id:this.id
        };
        let res = await saveShopApply(params);
        if (res && res.msg) {
          // 调用 selectShopApplyByCompanyId 接口
          let res2 = await selectShopApplyByCompanyId();
          let shopData = res2.data
          let identityObjStr = localStorage.getItem("identityObj");
          let identityObj = JSON.parse(identityObjStr);
          identityObj.content.shop = shopData;
          localStorage.setItem("identityObj", JSON.stringify(identityObj));
          this.$router.push({
            path: '/memberCenter/businessCenter/statistics',
          })
          this.$message.success(res.msg); // 显示成功消息
        } else {
          this.$message.error(res.msg);
          return false;
        }
      }


    },

    async submitForm() {
      // 提交申请
      const valid = await new Promise((resolve, reject) => {
        this.$refs.registrationForm.validate((valid) => {
          resolve(valid);
        });
      });

      if (valid) {
        // 表单提交逻辑
        console.log(this.formData, "查看this.form");
        // this.$message.success('提交成功，我们将在3个工作日内完成审核')
        let params = {
          ...this.formData,
          draftFlag: 0,
          id:this.id
        };

        let res = await saveShopApply(params); // 这里可以使用await
        // 检查响应并处理
        if (res && res.msg) {
          this.$message.success(res.msg); // 显示成功消息
          // if (this.identityObj.content.shop) {
            // 调用 selectShopApplyByCompanyId 接口
            let res2 = await selectShopApplyByCompanyId();
            let shopData = res2.data
            // console.log(shopData, '查看shopData')
            let identityObjStr = localStorage.getItem("identityObj");
            let identityObj = JSON.parse(identityObjStr);
            identityObj.content.shop = shopData;
            localStorage.setItem("identityObj", JSON.stringify(identityObj));
          // }

          this.$router.push({
            path: '/memberCenter/businessCenter/statistics',
          })
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      }
    },

    // 数据访问层
    showBasicInformation() {
      //当没有保存过草稿时回显数据
      if (this.identityObj.content.shop) return;
      // 将基础数据回显到数据层
      const {
        identityName,
        userName,
        contactName,
        contactPhone,
        address,
        affiliatedBank,
        bankCardId,
        userCardFrontImg,
        userCardBackImg,
        businessLicense,
      } = this.identityObj.content;
      this.formData = {
        name: identityName, //法人姓名
        phone: userName, //法人手机号
        contactPerson: contactName, //联系人
        contactPhone: contactPhone, // 联系电话
        address: address, // 经营地址
        bankCardNum: bankCardId, // 对公账户
        bankName: affiliatedBank, // 开户行
        // publicAccountName: bankAccountName, // 对公账户名
        bossCardFront: userCardFrontImg, // 身份证正面
        bossCardBack: userCardBackImg, // 身份证反面
        businessLicense: businessLicense, // 营业执照
      };
      //营业执照
      this.BigBusinessLicense = businessLicense
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + businessLicense]
        : [];
      this.businessLicenseList = businessLicense
        ? [
          {
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + businessLicense,
          },
        ]
        : [];
      //身份证正面
      this.BigBossCardFront = userCardFrontImg
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + userCardFrontImg]
        : [];
      this.bossCardFrontList = userCardFrontImg
        ? [
          {
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + userCardFrontImg,
          },
        ]
        : [];

      //身份证反面
      this.BigbossCardBack = userCardBackImg
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + userCardBackImg]
        : [];
      this.bossCardBackList = userCardBackImg
        ? [
          {
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + userCardBackImg,
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
          },
        ]
        : [];
      // console.log(this.BigBusinessLicense, '查看这是什么')
    },
    getiIsShop() {
      //当保存过草稿时
      if (!this.identityObj.content.shop) return;
      //新数据
      const {
        name,
        phone,
        contactPerson,
        contactPhone,
        address,
        businessLicense,
        bossCardFront,
        bossCardBack,
        bankCardNum,
        bankCompanyName,
        bankName,
        id
      } = this.identityObj.content.shop;
      this.formData = {
        name,
        phone,
        contactPerson,
        contactPhone,
        address,
        businessLicense,
        bossCardFront,
        bossCardBack,
        bankCardNum,
        bankCompanyName,
        bankName,

      };
      this.id = id
      //营业执照
      this.BigBusinessLicense = businessLicense
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + businessLicense]
        : [];
      this.businessLicenseList = businessLicense
        ? [
          {
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + businessLicense,
          },
        ]
        : [];
      //身份证正面
      this.BigBossCardFront = bossCardFront
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + bossCardFront]
        : [];
      this.bossCardFrontList = bossCardFront
        ? [
          {
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + bossCardFront,
          },
        ]
        : [];
      //身份证反面
      this.BigbossCardBack = bossCardBack
        ? [this.baseUrl + "admin/file/get?ossFilePath=" + bossCardBack]
        : [];
      this.bossCardBackList = bossCardBack
        ? [
          {
            url:
              this.baseUrl + "admin/file/get?ossFilePath=" + bossCardBack,
            uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
          },
        ]
        : [];
      //旧数据
      // const {
      //   bossName,
      //   userName,
      //   contactName,
      //   contactPhone,
      //   address,
      //   affiliatedBank,
      //   bankCardId,
      //   userCardFrontImg,
      //   userCardBackImg,
      //   businessLicense,
      // } = this.identityObj.content.shop;
      // this.formData = {
      //   name: bossName, //法人姓名
      //   phone: userName, //法人手机号
      //   contactPerson: contactName, //联系人
      //   contactPhone: contactPhone, // 联系电话
      //   address: address, // 经营地址
      //   bankCardNum: bankCardId, // 对公账户
      //   bankName: affiliatedBank, // 开户行
      //   // publicAccountName: bankAccountName, // 对公账户名
      //   bossCardFront: userCardFrontImg, // 身份证正面
      //   bossCardBack: userCardBackImg, // 身份证反面
      //   businessLicense: businessLicense, // 营业执照
      // };




      // console.log('这里执行了吗')
      //  const { isShop } = this.identityObj
      // 营业执照
      // let url = this.identityObj.businessLicense
      // this.formData.name = this.identityObj.shop.name;
      // this.formData.businessLicense = this.identityObj.businessLicense;
      // this.businessLicenseList = [
      //   {
      //     uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
      //     url:
      //       this.baseUrl +
      //       "admin/file/get?ossFilePath=" +
      //       this.identityObj.shop.businessLicense,
      //   },
      // ];

      // this.BigBusinessLicense = [
      //   this.baseUrl +
      //   "admin/file/get?ossFilePath=" +
      //   this.identityObj.shop.businessLicense,
      // ];

      // // //身份证正面
      // this.BigBossCardFront = [
      //   this.baseUrl +
      //   "admin/file/get?ossFilePath=" +
      //   this.identityObj.shop.bossCardFront,
      // ];
      // this.bossCardFrontList = [
      //   {
      //     uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
      //     url:
      //       this.baseUrl +
      //       "admin/file/get?ossFilePath=" +
      //       this.identityObj.shop.bossCardFront,
      //   },
      // ];
      // this.formData.bossCardFront = this.identityObj.shop.bossCardFront;

      // // //身份证反面
      // this.BigbossCardBack = [
      //   this.baseUrl +
      //   "admin/file/get?ossFilePath=" +
      //   this.identityObj.shop.bossCardBack,
      // ];
      // this.bossCardBackList = [
      //   {
      //     url:
      //       this.baseUrl +
      //       "admin/file/get?ossFilePath=" +
      //       this.identityObj.shop.bossCardBack,
      //     uid: Date.now() + "-businessLicense", // 为文件生成唯一的uid
      //   },
      // ];

      // this.formData.bankCardNum = this.identityObj.shop.bankCardNum;
      // this.formData.bankCompanyName = this.identityObj.shop.bankCompanyName;
      // this.formData.bankName = this.identityObj.shop.bankName;
      // this.formData.address = this.identityObj.shop.address;
      // this.formData.phone = this.identityObj.shop.phone;
      // this.formData.contactPerson = this.identityObj.shop.contactPerson;
      // this.formData.contactPhone = this.identityObj.shop.contactPhone;
      //对公账户
    },
  },
};
</script>

<style lang="less" scoped>
.supplier-registration {
  padding: 20px;
  background-color: white;
  min-height: 100vh;

  .page-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .page-desc {
    text-align: center;
    color: #666;
    margin-bottom: 30px;
  }

  .form-card {
    max-width: 1000px;
    margin: 0 auto;

    .section-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
    }
  }

  .registration-form {
    padding: 10px 10px;
  }

  .upload-tips {
    color: #909399;
    font-size: 12px;
    margin-bottom: 10px;
  }

  .license-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    .el-button {
      width: 100%;
      height: 100%;
    }

    .uploaded-img {
      width: 100%;
      text-align: center;

      img {
        max-width: 100%;
        max-height: 200px;
      }
    }
  }

  .id-card-container {
    width: 80%;
    display: flex;
    justify-content: space-between;
  }

  .id-card-container {
    display: flex;
    justify-content: space-between;

    .id-card-uploader {
      width: 48%;
      height: 160px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .upload-box {
        // background: red;
        text-align: center;
        color: #909399;

        i {
          font-size: 28px;
          color: #c0c4cc;
        }

        .upload-status {
          margin-top: 5px;
          font-size: 12px;
        }
      }

      .uploaded-img {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          max-width: 100%;
          max-height: 150px;
        }
      }
    }
  }

  .form-buttons {
    margin-top: 30px;
  }
}

.no-image {
  /deep/.el-upload {
    display: none !important;
  }
}
</style>
